import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'dashboard',
    title: 'OSC Form Generator',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
  },
  {
    path: 'form',
    title: 'OSC Form Generator',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/form/form').then((m) => m.Form),
  },
  {
    path: 'form/:id',
    title: 'OSC Form Generator',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/form/form').then((m) => m.Form),
  },
  {
    path: 'label-preview',
    title: 'Avery 5264 Label Preview | OSC Form Generator',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/label-preview/label-preview').then((m) => m.LabelPreview),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
